import React, { useEffect, useRef, useState } from "react";
import { Image } from "antd";
import { MainWrapper } from "../component/MainWrapper";
import { FormattedMessage, useIntl } from "react-intl";
import { TopBar } from "../component/TopBar";
import { Link, useParams } from "react-router-dom";
import EmailLink from "sr/helpers/ui-components/EmailLink";
import { useGet } from "../Hooks/Api/useGet";
import { getWorkorder } from "sr/utils/api/company/workorder/getWorkorder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faMapMarker,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import PhoneNumberFormat from "sr/helpers/functions/PhoneNumberFormat";
import { getTask } from "sr/utils/api/company/customer/getTask";
import { getManageTaskSubmit } from "sr/utils/api/company/workorder/getManageTaskSubmit";
import { getTaskManage } from "sr/utils/api/company/workorder/getTaskManage";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { Empty } from "../candidates/component/Empty";
import { ModelWrapperWithButton } from "../component/ModelWrapperWithButton";
import { setPreview } from "app/pages/jobs/Myjobs/function/setPreview";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import getLabelByValue from "sr/helpers/functions/getLabelByValue";
import { TaskStatus } from "sr/i18n/messages/setting";
import { getFiles } from "sr/utils/api/getFiles";
import { getFile } from "sr/utils/api/getFile";
import { toast } from "react-toastify";
import { Button } from "sr/helpers/ui-components/company/Button";
import { useSelector } from "react-redux";
import { RootState } from "sr/redux/store";
import { getUserFullProfile } from "sr/utils/api/user/user";
import { FeeBreakdownBox } from "app/pages/component/FeeBreakdownBox";
import { getFeeTransparency } from "sr/utils/api/fee/getFeeTransparency";
import { DateFormat } from "sr/helpers/functions/DateFormat";
import { StringTimeFormat } from "sr/helpers/functions/StringTimeFormat";
import moment from "moment";

export const WorkOrderProgress = () => {
  const intl = useIntl();
  const taskDetailsLabel = intl.formatMessage({
    id: "WORKORDER.DETAILS.TASK_DETAILS",
  });
  const contractorLabel = intl.formatMessage({
    id: "RECRUITER.SCHEDULEWORKORDER.INPUT.CONTRACTOR.TITLE",
  });
  const supervisorLabel = intl.formatMessage({
    id: "RECRUITER.SCHEDULEWORKORDER.INPUT.SUPERVISOR.TITLE",
  });
  const statusLabel = intl.formatMessage({
    id: "SUPERVISOR.PENDING.JOB.TABLE.COL.NAME.STATUS",
  });
  const remarkLabel = intl.formatMessage({
    id: "SUPERVISOR.PENDING.JOB.REMARK.TITLE",
  });
  const imageLabel = intl.formatMessage({
    id: "COMMON.IMAGE",
  });
  const videoLabel = intl.formatMessage({
    id: "COMMON.VIDEO",
  });
  const notAvailable = intl.formatMessage({
    id: "COMMON.NOT_AVAILABLE",
  });
  const notCompleted = intl.formatMessage({
    id: "COMMON.NOT_COMPLETED",
  });
  const emptyLabel = intl.formatMessage({
    id: "COMMON.EMPTY",
  });
  const pendingLabel = intl.formatMessage({
    id: "COMMON.PENDING",
  });
  const hoursLabel = intl.formatMessage({
    id: "COMMON.HOURS",
  });
  const [isTaskSubmitted, setIsTaskSubmitted] = useState(false);
  const [id, setId] = useState<string>();
  const params = useParams();
  const [previewImages, setPreviewImages] = useState<any>([]);
  const [imagePreviewOpen, setImagePreviewOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [previewVideo, setPreviewVideo] = useState<any>([]);
  const [userFullProfile, setUserFullProfile] = useState<any>({});
  const appSettingsData = useSelector((s: RootState) => s.appSettings.data);
  const {
    getData: getWorkOrders,
    data: workorder,
    loader: loaders,
    pageination: pageination,
  }: any = useGet();
  const { data: tasks, getData: getTasks, loader: taskLoader } = useGet();
  const {
    data: managetasks,
    getData: getManageTaskList,
    loader: taskmanageLoader,
  } = useGet();
  const {
    data: submittask,
    getData: getTaskSubmitted,
    loader: trackloader,
  } = useGet();
  const [profileImg, setProfileImg] = useState(null);
  const [feeTransparency, setFeeTransparency] = useState<any>(null);
  const [feeTransparencyLoading, setFeeTransparencyLoading] = useState(false);
  const feeTransparencyReqIdRef = useRef(0);
  const formatActualTime = (value) => {
    if (!value) return null;
    const dateObject = new Date(value);
    const hours = String(dateObject.getHours());
    const minutes = String(dateObject.getMinutes()).padStart(2, "0");
    return StringTimeFormat(`${hours}:${minutes}`);
  };

  useEffect(() => {
    (async () => {
      const userFullProfileRes = await getUserFullProfile();

      setUserFullProfile(userFullProfileRes?.data);
    })();
  }, []);

  useEffect(() => {
    const { id } = params;
    setId(id);
  }, [params]);
  useEffect(() => {
    if (submittask?.length > 0) {
      setIsTaskSubmitted(true);
    } else {
      setIsTaskSubmitted(false);
    }
  }, [submittask]);
  useEffect(() => {
    const fetchWorkOrder = async (id) => {
      const queryParams = new URLSearchParams();
      if (id) queryParams.append("id", id);
      await getWorkOrders(() => getWorkorder(queryParams));
    };
    if (id) {
      fetchWorkOrder(id);
      fetchManageTask(id);
    }
  }, [id]);
  const onCheckModelVideo = (data) => {
    setPreviewVideo([]);
  };

  const imagePreviewItems = previewImages
    ?.map((preview) => preview?.blob)
    ?.filter(Boolean);

  useEffect(() => {
    if (imagePreviewItems?.length > 0) {
      setImagePreviewOpen(true);
    }
  }, [imagePreviewItems?.length]);

  const handleImagePreviewOpenChange = (open) => {
    setImagePreviewOpen(open);
    if (!open) {
      setPreviewImages([]);
    }
  };

  const fetchManageTask = async (workorderId) => {
    const queryParams = new URLSearchParams();
    if (workorderId) queryParams?.append("workorder_id", workorderId);
    await getTaskSubmitted(() => getManageTaskSubmit(queryParams));
    await getManageTaskList(() => getTaskManage(queryParams));
  };

  useEffect(() => {
    const fetchTasks = async (checklistId) => {
      const queryParams = new URLSearchParams();
      queryParams.append("checklist_id", checklistId);

      await getTasks(() => getTask(queryParams));
    };
    if (workorder?.checklist_id?._id) {
      fetchTasks(workorder?.checklist_id?._id);
    }
  }, [workorder?.checklist_id?._id]);
  const HandleImageView = (taskId) => {
    setLoader(true);
    const images = managetasks?.find(
      (data) => data?.task_id?._id === taskId,
    )?.images;
    if (images) {
      setPreview({
        type: "images",
        files: images,
        setPreviewImages: setPreviewImages,
        previewImages: previewImages,
        setLoader: setLoader,
      });
    }
  };
  const HandleVideoView = (taskId) => {
    setLoader(true);
    const videos = managetasks?.find(
      (data) => data?.task_id?._id === taskId,
    )?.videos;
    if (videos) {
      setPreview({
        type: "videos",
        files: videos,
        setPreviewVideo: setPreviewVideo,
        previewVideo: previewVideo,
        setLoader: setLoader,
      });
    }
  };

  const calculateAmount = (payType, rate, hours) => {
    if (payType === "Fixed Rate") {
      return rate;
    }
    if (payType === "Hourly Rate") {
      return rate * hours;
    }
  };

  useEffect(() => {
    const txDetail = workorder?.payment_transaction_detail;
    if (txDetail) {
      setFeeTransparency(txDetail);
      setFeeTransparencyLoading(false);
      return;
    }

    const amount = Number(workorder?.pay_type_rate);
    if (!amount || Number.isNaN(amount) || amount <= 0) {
      setFeeTransparency(null);
      setFeeTransparencyLoading(false);
      return;
    }

    const reqId = feeTransparencyReqIdRef.current + 1;
    feeTransparencyReqIdRef.current = reqId;
    setFeeTransparencyLoading(true);
    (async () => {
      try {
        const res = await getFeeTransparency({ jobType: "workorder", amount });
        if (feeTransparencyReqIdRef.current !== reqId) return;
        if (res?.success === true) {
          setFeeTransparency(res?.data || null);
        } else {
          setFeeTransparency(null);
        }
      } catch (e) {
        if (feeTransparencyReqIdRef.current !== reqId) return;
        setFeeTransparency(null);
      } finally {
        if (feeTransparencyReqIdRef.current !== reqId) return;
        setFeeTransparencyLoading(false);
      }
    })();
  }, [workorder?.payment_transaction_detail, workorder?.pay_type_rate]);
  const handledata = (id) => {
    return "";
  };

  const fetchProfileImg = async (cleanerId) => {
    const params = {
      cleaner_id: cleanerId,
    };
    const profileImg = await getFiles(params);
    if (profileImg?.success === true) {
      const filterfile = profileImg?.data?.filter(
        (item) => item?.file?.fieldname === "profile_img",
      );
      if (filterfile && filterfile[0]?.file?.key) {
        const fileimg = await getFile(filterfile[0]?.file?.key);
        if (fileimg) {
          // const rawImageData = new Uint8Array(fileimg as ArrayBuffer);
          // const blob = new Blob([rawImageData], { type: 'image/png' });
          const newImageUrl = URL.createObjectURL(fileimg);
          setProfileImg(newImageUrl);
          return true;
        }
      }
    }
  };

  useEffect(() => {
    if (workorder?.contractor_id?.cleaner_id) {
      fetchProfileImg(workorder?.contractor_id?.cleaner_id);
    }
  }, [workorder?.contractor_id?.cleaner_id]);

  return (
    <MainWrapper>
      {loader && <LoaderFullScreen />}
      <div className="py-3">
        <TopBar
          title={
            <FormattedMessage
              id="RECRUITER.WORKORDER.DETAILS.TITLE"
              defaultMessage="Work Order"
            />
          }
          btntitle={
            <FormattedMessage
              id="RECRUITER.WORKORDER.ALL.TITLE"
              defaultMessage="All Work Order"
            />
          }
          btntitlelink="/work-order"
          postButton={
            <Button
              text={
                <FormattedMessage
                  id="RECRUITER.WORKORDER.ADD.WORK.ORDER"
                  defaultMessage="Add Work Order"
                />
              }
              disabled={
                appSettingsData &&
                appSettingsData?.isPlatformPaymentActive != undefined &&
                appSettingsData?.isPlatformPaymentActive === true &&
                !userFullProfile?.id
              }
              onClick={() => {
                if (
                  appSettingsData &&
                  appSettingsData?.isPlatformPaymentActive != undefined &&
                  appSettingsData?.isPlatformPaymentActive === true
                ) {
                  if (
                    !userFullProfile?.id ||
                    !userFullProfile?.stripe_customer_detail ||
                    !userFullProfile?.stripe_customer_detail?.id ||
                    !userFullProfile?.stripe_customer_payment_methods ||
                    userFullProfile?.stripe_customer_payment_methods?.length ==
                      0
                  ) {
                    toast.error(
                      intl.formatMessage({
                        id: "API.ERROR.PAYMENTMETHOD.NOT.FOUND",
                        defaultMessage:
                          "Please set up your payment method first",
                      }),
                    );
                    return;
                  }
                  if (
                    !userFullProfile?.stripe_customer_detail ||
                    !userFullProfile?.stripe_customer_detail
                      ?.default_payment_method ||
                    userFullProfile?.stripe_customer_detail
                      ?.default_payment_method == null ||
                    userFullProfile?.stripe_customer_detail
                      ?.default_payment_method == "null" ||
                    userFullProfile?.stripe_customer_detail
                      ?.default_payment_method == ""
                  ) {
                    toast.error(
                      intl.formatMessage({
                        id: "API.ERROR.PAYMENTMETHOD.DEFAULT.NOT.FOUND",
                        defaultMessage:
                          "Please set a default payment method first",
                      }),
                    );
                    return;
                  }
                }
                window.location.href = "/schedule-work-order";
              }}
            ></Button>
            // <Link
            //   to="/schedule-work-order"
            //   className="rounded-lg font-bold bg-[#ff39b3] font-bold px-5 py-3  text-white cursor-pointer hover:bg-navy"
            // >
            //   <FormattedMessage
            //     id="RECRUITER.WORKORDER.ADD.WORK.ORDER"
            //     defaultMessage="Add Work Order"
            //   />
            // </Link>
          }
          className="px-10"
        ></TopBar>
        <ContentWithSpinner loader={taskmanageLoader} height="h-screen">
          <div className="px-10">
            <div className="flex">
              <div className="bg-white rounded-lg p-5 w-[120rem] shadow-boxshadowpage">
                <div className="flex justify-between gap-6 mb-5">
                  <div className="flex space-x-5">
                    <div className="w-40 h-40">
                      <div className="transform lg:transform-none -translate-x-1/2">
                        <img
                          alt="Profile"
                          className="rounded"
                          src={`${
                            profileImg
                              ? profileImg
                              : "/media/icons/displayProfilePlaceholder.png"
                          } `}
                        />
                      </div>
                    </div>
                    <div className="pb-5 pt-2">
                      <h1 className="text-3xl  text-[#595959]">
                        {workorder?.contractor_id?.first_name}{" "}
                        {workorder?.contractor_id?.last_name}
                      </h1>
                      <div className="mt-3 font-700 text-[16px]">
                        <FontAwesomeIcon icon={faEnvelope} className="pr-1" />{" "}
                        <EmailLink
                          email={workorder?.contractor_id?.email}
                          subject="Hello"
                          body="Hi, how are you?"
                        ></EmailLink>
                      </div>
                      <div className="mt-2 text-[14px]">
                        <FontAwesomeIcon icon={faPhone} className="pr-3" />
                        {PhoneNumberFormat(
                          workorder?.contractor_id?.mobile_number,
                        )}
                      </div>
                      <div className="flex justify-start space-x-3 items-center">
                        <div className="mt-2 text-[14px]">
                          <FontAwesomeIcon
                            icon={faMapMarker}
                            className="pl-1 pr-3 cursor-pointer"
                          />
                          {workorder?.contractor_id?.address?.address_line_1}{" "}
                          {workorder?.contractor_id?.address?.address_line_2}{" "}
                          {workorder?.contractor_id?.address?.city}{" "}
                          {workorder?.contractor_id?.address?.state}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="px-10 mt-3">
            <div className="bg-white rounded-lg p-5 shadow-boxshadowpage">
              <h2 className="text-xl border-b-2 text-center py-3">
                <FormattedMessage id="WORKORDER.DETAILS.TITLE" />
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-6 pt-5">
                <div className="min-w-0">
                  <p className="font-bold">
                    <FormattedMessage id="WORKORDER.TABLE.COL.WORKORDER.TITLE" />
                    :
                  </p>
                  <p className="text-gray-700 break-words">
                    {workorder?.title || notAvailable}
                  </p>
                </div>
                <div className="min-w-0">
                  <p className="font-bold">
                    <FormattedMessage id="WORKORDER.TABLE.COL.CUSTOMER.NAME.TITLE" />
                    :
                  </p>
                  <p className="text-gray-700 break-words">
                    {workorder?.customer_id?.name || notAvailable}
                  </p>
                </div>
                <div className="min-w-0">
                  <p className="font-bold">
                    <FormattedMessage id="WORKORDER.TABLE.COL.NAME.LOCATION" />:
                  </p>
                  <p className="text-gray-700 break-words">
                    {[
                      workorder?.customer_location_id?.name,
                      workorder?.customer_location_id?.address?.address_line_1,
                      workorder?.customer_location_id?.address?.address_line_2,
                      workorder?.customer_location_id?.address?.city,
                    ]
                      .filter(Boolean)
                      .join(", ") || notAvailable}
                  </p>
                </div>
                <div className="min-w-0">
                  <p className="font-bold">
                    <FormattedMessage id="CLEANER.JOBS.FILTER.JOBTYPE" />:
                  </p>
                  <p className="text-gray-700 break-words">
                    {workorder?.job_type || notAvailable}
                  </p>
                </div>
                <div className="min-w-0">
                  <p className="font-bold">
                    <FormattedMessage id="PENDING.JOBS.TEXT.TYPE" />:
                  </p>
                  <p className="text-gray-700 break-words">
                    {workorder?.type || notAvailable}
                  </p>
                </div>
                <div className="min-w-0">
                  <p className="font-bold">
                    <FormattedMessage id="WORKORDER.TABLE.COL.NAME.SCHEDULE.DATE" />
                    :
                  </p>
                  <p className="text-gray-700">
                    {DateFormat(workorder?.one_time_date) || notAvailable}
                  </p>
                </div>
                <div className="min-w-0">
                  <p className="font-bold">
                    <FormattedMessage id="PENDING.JOBS.TEXT.TITLE.ENTRYTIME" />:
                  </p>
                  <p className="text-gray-700">
                    {StringTimeFormat(workorder?.entry_time) || notAvailable}
                  </p>
                </div>
                <div className="min-w-0">
                  <p className="font-bold">
                    <FormattedMessage id="PENDING.JOBS.TEXT.TITLE.EXITTIME" />:
                  </p>
                  <p className="text-gray-700">
                    {StringTimeFormat(workorder?.exit_time) || notAvailable}
                  </p>
                </div>
                <div className="min-w-0">
                  <p className="font-bold">
                    <FormattedMessage id="WORKORDER.DETAILS.ACTUAL_ENTRY_TIME" />
                    :
                  </p>
                  <p className="text-gray-700">
                    {workorder?.work_start_date_time_utc
                      ? moment(workorder?.work_start_date_time_utc)
                          .format("hh:mm A")
                      : notAvailable}
                  </p>
                </div>
                <div className="min-w-0">
                  <p className="font-bold">
                    <FormattedMessage id="WORKORDER.DETAILS.ACTUAL_EXIT_TIME" />
                    :
                  </p>
                  <p className="text-gray-700">
                    {workorder?.work_end_date_time_utc
                      ? moment(workorder?.work_end_date_time_utc)
                          .format("hh:mm A")
                      : notAvailable}
                  </p>
                </div>
                <div className="min-w-0">
                  <p className="font-bold">
                    <FormattedMessage id="WORKORDER.TABLE.COL.NAME.COMPLETION.DATE" />
                    :
                  </p>
                  <p className="text-gray-700">
                    {workorder?.work_end_date_time_utc
                      ? moment(workorder?.work_end_date_time_utc)
                          .format("MM/DD/YYYY")
                      : notAvailable}
                  </p>
                </div>
                <div className="min-w-0">
                  <p className="font-bold">
                    <FormattedMessage id="WORKORDER.DETAILS.TIME_FOR_COMPLETION" />
                    :
                  </p>
                  <p className="text-gray-700">
                    {workorder?.time_for_work_completion
                      ? `${workorder?.time_for_work_completion} ${hoursLabel}`
                      : notAvailable}
                  </p>
                </div>
                <div className="xl:col-span-3">
                  <p className="font-bold">
                    <FormattedMessage id="RECRUITER.SCHEDULEWORKORDER.INPUT.DESCRIPTION.TITLE" />
                    :
                  </p>
                  <p className="text-gray-700 break-words">
                    {workorder?.description || notAvailable}
                  </p>
                </div>
                <div className="xl:col-span-3">
                  {feeTransparencyLoading || feeTransparency ? (
                    <div className="mt-1 max-w-[320px]">
                      <FeeBreakdownBox
                        loading={feeTransparencyLoading}
                        rows={[
                          {
                            label: intl.formatMessage({
                              id: "COMMON.SERVICE_AMOUNT",
                            }),
                            value: Number(feeTransparency?.amount || 0),
                          },
                          {
                            label: intl.formatMessage({
                              id: "COMMON.SERVICE_FEE",
                            }),
                            value: Number(
                              feeTransparency?.job_provider_fee_amount || 0,
                            ),
                          },
                        ]}
                        totalLabel={intl.formatMessage({
                          id: "COMMON.TOTAL_PAYABLE",
                        })}
                        totalValue={Number(
                          feeTransparency?.job_provider_paid_amount || 0,
                        )}
                        status={workorder?.payment_transaction_detail?.status}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          {isTaskSubmitted ? (
            <div className="pt-3 w-full px-10">
              <div className="bg-white rounded-lg p-5 shadow-boxshadowpage">
                <div className="items-start border-b border-neutral-200">
                  <div className="flex w-full divide-x-2">
                    <p className=" text-xl border-b-2 text-center py-3 w-[30%]">
                      {taskDetailsLabel}
                    </p>
                    <div className="w-[40%]">
                      <p className=" text-xl border-b-2 text-center py-3">
                        {contractorLabel}
                      </p>
                      <div className="flex">
                        <p className="text-base  border-b-2 py-3 text-center w-[25%]">
                          {statusLabel}
                        </p>
                        <p className="text-base  border-b-2 py-3 text-center w-[25%]">
                          {remarkLabel}
                        </p>
                        <p className="text-base  border-b-2 py-3 text-center w-[25%]">
                          {imageLabel}
                        </p>
                        <p className="text-base  border-b-2 py-3 text-center w-[25%]">
                          {videoLabel}
                        </p>
                      </div>
                    </div>
                    <div className="w-[30%]">
                      <p className=" text-xl border-b-2 text-center py-3">
                        {supervisorLabel}
                      </p>
                      <div className="flex">
                        <p className="text-base  border-b-2 py-3 text-center w-[50%]">
                          {statusLabel}
                        </p>
                        <p className="text-base  border-b-2 py-3 text-center w-[50%]">
                          {remarkLabel}
                        </p>
                      </div>
                    </div>
                  </div>
                  {tasks?.map((data, index) => (
                    <div className="flex divide-x-2 border-b-2">
                      <div className="w-[30%]">
                        <div className="pl-3">
                          <h2 className="">
                            <span className="">
                              <FormattedMessage id="SUPERVISOR.PENDING.JOB.TASK.TITLE" />
                              :
                            </span>{" "}
                            {data?.name}
                          </h2>
                          <div>{data?.description}</div>
                          <div>
                            <span className="">
                              <FormattedMessage id="PENDING.JOBS.TEXT.TYPE" />:
                            </span>{" "}
                            {data?.type}
                          </div>{" "}
                        </div>
                      </div>
                      <div className="w-[40%]">
                        <div className="flex text-center">
                          <div className="w-[25%]">
                            <p>
                              {getLabelByValue(
                                managetasks?.find(
                                  (item) => item?.task_id?._id === data?.id,
                                )?.contractor_status,
                                TaskStatus,
                              ) || notCompleted}
                            </p>
                          </div>
                          <div className="w-[25%]">
                            <p>
                              {managetasks?.find(
                                (item) => item?.task_id?._id === data?.id,
                              )?.contractor_remarks || notAvailable}
                            </p>
                          </div>
                          <div className="w-[25%] flex justify-center">
                            {managetasks?.find(
                              (tasks) => tasks?.task_id?._id === data?.id,
                            )?.images?.length > 0 ? (
                              <svg
                                onClick={() => HandleImageView(data?.id)}
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                className="w-6 h-6 cursor-pointer"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                                />
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                                />
                              </svg>
                            ) : (
                              <p>{emptyLabel}</p>
                            )}
                          </div>
                          <div className="w-[25%] flex justify-center">
                            {managetasks?.find(
                              (tasks) => tasks?.task_id?._id === data?.id,
                            )?.videos?.length > 0 ? (
                              <svg
                                onClick={() => HandleVideoView(data?.id)}
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                className="w-6 h-6 cursor-pointer"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                                />
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                                />
                              </svg>
                            ) : (
                              <p>{emptyLabel}</p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="w-[30%]">
                        <div className="flex text-center">
                          <div className="w-[50%]">
                            <div>{handledata(data?.id)}</div>
                            <p>
                              {getLabelByValue(
                                managetasks?.find(
                                  (item) => item?.task_id?._id === data?.id,
                                )?.supervisor_status,
                                TaskStatus,
                              ) || pendingLabel}
                            </p>
                          </div>
                          <div className="w-[50%]">
                            <p>
                              {managetasks?.find(
                                (item) => item?.task_id?._id === data?.id,
                              )?.supervisor_remarks || notAvailable}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  {submittask &&
                    submittask[0]?.contractor_status === "completed" &&
                    submittask &&
                    submittask[0]?.supervisor_status === "completed" && (
                      <div className="py-5">
                        <div className="text-center">
                          <p>
                            {intl.formatMessage(
                              {
                                id: "COMMON.WORK_ORDER_COMPLETED_APPROVED_HOURS",
                                defaultMessage:
                                  "Work Order completed with approved {hours} hours successfully",
                              },
                              { hours: submittask?.[0]?.approve_time },
                            )}
                          </p>
                        </div>
                        {/* <div className="text-center">
   <div>{workorder?.pay_type} : $  {workorder?.pay_type_rate}</div>
   <div><span>Total Amount</span> : $ {calculateAmount(workorder?.pay_type, workorder?.pay_type_rate, submittask[0]?.approve_time)}</div>
   </div> */}
                      </div>
                    )}
                </div>
              </div>
            </div>
          ) : (
            <Empty
              text={intl.formatMessage({
                id: "COMMON.NO_TASKLIST_FROM_BOTH_SIDES",
              })}
            />
          )}
        </ContentWithSpinner>
      </div>
      <Image.PreviewGroup
        items={imagePreviewItems}
        classNames={{
          popup: {
            root: "checklist-image-preview",
          },
        }}
        styles={{
          popup: {
            mask: {
              background: "rgba(3, 7, 18, 0.82)",
            },
            footer: {
              color: "#fff",
              textShadow: "0 1px 2px rgba(0, 0, 0, 0.8)",
            },
            actions: {
              background: "rgba(17, 24, 39, 0.96)",
              border: "1px solid rgba(255, 255, 255, 0.22)",
              boxShadow: "0 12px 32px rgba(0, 0, 0, 0.38)",
              color: "#fff",
            },
          },
        }}
        preview={{
          open: imagePreviewOpen && imagePreviewItems?.length > 0,
          onOpenChange: handleImagePreviewOpenChange,
          countRender: () => null,
        }}
      />
      <ModelWrapperWithButton
        showModal={previewVideo?.length}
        onCheckModel={onCheckModelVideo}
        nofooter={true}
      >
        <div className="flex justify-center">
          {previewVideo?.map((preview) => (
            <video className="h-96 w-96" controls>
              <source src={preview?.blob} type="video/mp4" />
            </video>
          ))}
        </div>
      </ModelWrapperWithButton>
    </MainWrapper>
  );
};
